import React from 'react';

export const BrazeContext = React.createContext({
    started: false,
});
